import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import HelpOutlineRoundedIcon from '@mui/icons-material/HelpOutlineRounded';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { TwemojiWrapper } from '../../../components/twemojiWrapper';
import { BOLD_FONT_FAMILY } from '../../../constants/constants';
import { DEFAULT_DARKER_BACKGROUND_COLOR3, ENTRY_SIDE_PANEL_BORDER_COLOR, ENTRY_SIDE_PANEL_TITLE_COLOR } from '../../../styles/colors';
const CONTAINER_CSS = css `
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 10px;
  margin: 10px;
  filter: drop-shadow(5px 5px 0 rgba(0, 0, 0, 0.1));
`;
const CONTAINER_CONTENTS_CSS = css `
  display: flex;
  flex-direction: column;
  width: 100%;
`;
const TYPOGRAPHY_CSS = css `
  font-family: ${BOLD_FONT_FAMILY};
  flex-grow: 1;
`;
const HEADER_CSS = css `
  display: flex;
  flex-direction: row;
  align-items: center;
  color: ${ENTRY_SIDE_PANEL_TITLE_COLOR};
  background-color: ${ENTRY_SIDE_PANEL_BORDER_COLOR};
  padding: 5px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
`;
const CONTENTS_CSS = css `
  background-color: ${DEFAULT_DARKER_BACKGROUND_COLOR3};
  padding: 5px;
  border: 2px solid ${ENTRY_SIDE_PANEL_BORDER_COLOR};
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
`;
export const EntrySidePanel = ({ title, children, contentsContainerStyle, gameGuidePage }) => {
    const navigate = useNavigate();
    const onClickInfo = useCallback(() => {
        if (!gameGuidePage) {
            return;
        }
        navigate(`guide/${gameGuidePage}`);
    }, [navigate, gameGuidePage]);
    return (_jsx("aside", { "aria-label": title, css: CONTAINER_CSS, children: _jsxs("div", { css: CONTAINER_CONTENTS_CSS, children: [_jsxs("div", { css: HEADER_CSS, children: [_jsx(Typography, { variant: 'h6', css: TYPOGRAPHY_CSS, "aria-hidden": true, children: _jsx(TwemojiWrapper, { children: title }) }), gameGuidePage && (_jsx(IconButton, { size: 'small', onClick: onClickInfo, title: title, color: 'inherit', children: _jsx(HelpOutlineRoundedIcon, {}) }))] }), _jsx("div", { css: CONTENTS_CSS, style: contentsContainerStyle, children: children })] }) }));
};
